import { apiRequest } from "./api";
import type {
  CreateMediaUploadRequest,
  CreateMediaUploadResponse,
  MediaFileResponse,
  MediaUsageType,
} from "../types/mediaTypes";

async function uploadToPresignedUrl(uploadUrl: string, file: File): Promise<void> {
  const response = await fetch(uploadUrl, {
    method: "PUT",
    headers: {
      "Content-Type": file.type,
    },
    body: file,
  });

  if (!response.ok) {
    throw new Error(`Upload failed with status ${response.status}`);
  }
}

export const mediaApi = {
  createUpload(payload: CreateMediaUploadRequest): Promise<CreateMediaUploadResponse> {
    return apiRequest<CreateMediaUploadResponse>("/api/media/uploads", {
      method: "POST",
      body: payload,
    });
  },

  completeUpload(mediaFileId: string): Promise<MediaFileResponse> {
    return apiRequest<MediaFileResponse>(`/api/media/uploads/${mediaFileId}/complete`, {
      method: "POST",
    });
  },

  removeProfilePhoto(): Promise<void> {
    return apiRequest<void>("/api/media/profile-photo", {
      method: "DELETE",
    });
  },

  async uploadFile(file: File, usageType: MediaUsageType, targetGigId?: string | null): Promise<MediaFileResponse> {
    const upload = await this.createUpload({
      usageType,
      targetGigId: targetGigId ?? null,
      fileName: file.name,
      contentType: file.type,
      sizeBytes: file.size,
    });

    await uploadToPresignedUrl(upload.uploadUrl, file);
    return this.completeUpload(upload.mediaFileId);
  },
};
